// Iter 649 (Kamel) — « J'ai bien lu » sans réseau : mémorisé sur le téléphone, envoyé tout seul au retour de la connexion.
const KEY = 'raav_lectures_attente';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const lire = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; } };
const ecrire = (l) => { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch { /* quota */ } };

export const enfilerLecture = (item) => {
  const l = lire().filter(x => !(x.note_id === item.note_id && x.reg_id === item.reg_id && x.action === item.action));
  l.push({ ...item, at: item.at || new Date().toISOString() });
  ecrire(l);
};

export const lecturesEnAttente = () => lire();

let enCours = false;
export const viderLectures = async () => {
  if (enCours || !navigator.onLine) return 0;
  const l = lire();
  if (!l.length) return 0;
  enCours = true;
  let ok = 0;
  const restantes = [];
  for (const it of l) {
    try {
      const r = await fetch(`${API}/espace-adherent/${it.token}/note/${it.note_id}/lecture`, { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ reg_id: it.reg_id, action: it.action, at: it.at }) });
      if (r.ok || (r.status >= 400 && r.status < 500)) ok += 1;  // 4xx = définitivement inutile (lien périmé…) : on ne boucle pas
      else restantes.push(it);
    } catch { restantes.push(it); }
  }
  ecrire(restantes);
  enCours = false;
  if (ok) window.dispatchEvent(new CustomEvent('raav-lectures-envoyees', { detail: { nb: ok } }));
  return ok;
};

let installe = false;
export const installerFileLectures = () => {
  if (installe) return;
  installe = true;
  window.addEventListener('online', () => { viderLectures(); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') viderLectures(); });
  setInterval(viderLectures, 60000);
  viderLectures();
};
